const cardItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Action%20film%20poster%20style%20with%20dramatic%20golden%20backlight%2C%20heroic%20figure%20silhouette%2C%20warm%20amber%20and%20deep%20black%20contrast%2C%20cinematic%20composition%2C%20movie%20promotional%20aesthetic%2C%20epic%20atmosphere&width=600&height=400&seq=card-01&orientation=landscape',
    title: '孤胆狙击',
    category: '动作 · 2024',
    desc: '特警队长孤身犯险，与犯罪集团展开生死较量。',
    tag: '热播',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20film%20atmosphere%20with%20dramatic%20lighting%2C%20dark%20rainy%20night%20scene%2C%20golden%20streetlamp%20glow%2C%20cinematic%20noir%20style%2C%20suspenseful%20movie%20poster%20aesthetic%2C%20deep%20shadows&width=600&height=400&seq=card-02&orientation=landscape',
    title: '长安十二夜',
    category: '悬疑 · 2024',
    desc: '古都长安连环奇案，迷雾重重步步惊心。',
    tag: '新片',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Drama%20film%20scene%20with%20warm%20emotional%20lighting%2C%20soft%20golden%20hour%20glow%2C%20cinematic%20portrait%20composition%2C%20gentle%20and%20touching%20movie%20poster%20style%2C%20nostalgic%20atmosphere&width=600&height=400&seq=card-03&orientation=landscape',
    title: '逆流而上',
    category: '剧情 · 2024',
    desc: '小镇青年北上追梦，逆境中的温暖人生。',
    tag: '推荐',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20movie%20scene%20with%20futuristic%20cityscape%2C%20glowing%20amber%20neon%20accents%2C%20cinematic%20wide%20shot%2C%20epic%20film%20poster%20aesthetic%2C%20dark%20space%20background%20with%20warm%20light%20streaks&width=600&height=400&seq=card-04&orientation=landscape',
    title: '机甲风暴2046',
    category: '科幻 · 2024',
    desc: '未来世界人机大战，视觉特效震撼登场。',
    tag: '热门',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20film%20atmosphere%20with%20magical%20golden%20light%20particles%2C%20ancient%20Chinese%20mythological%20style%2C%20cinematic%20composition%2C%20ethereal%20mist%20and%20warm%20glow%2C%20epic%20movie%20poster%20aesthetic&width=600&height=400&seq=card-05&orientation=landscape',
    title: '山海传说',
    category: '奇幻 · 2024',
    desc: '上古神话新演绎，瑰丽奇幻的东方传奇。',
    tag: '精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Comedy%20film%20scene%20with%20bright%20warm%20lighting%2C%20joyful%20family%20gathering%2C%20cinematic%20golden%20hour%20glow%2C%20cheerful%20movie%20poster%20style%2C%20lively%20festive%20atmosphere&width=600&height=400&seq=card-06&orientation=landscape',
    title: '欢乐一家人',
    category: '喜剧 · 2024',
    desc: '三代同堂笑料百出，温馨治愈的家庭喜剧。',
    tag: '热播',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            本周推荐影片
          </h2>
          <p className="text-foreground-500 text-sm">编辑精选，品质保证的91电影免费资源</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {cardItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl overflow-hidden group cursor-pointer hover:scale-[1.02] transition-transform duration-300"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100/80 via-transparent to-transparent"></div>
                <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <span className="text-foreground-500 text-xs">{item.category}</span>
                <h3 className="text-lg font-heading text-foreground-950 mt-1 mb-2">{item.title}</h3>
                <p className="text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}